export const PIXEL_ID = "2003274333725911";

/**
 * Fire a Meta Pixel standard event. Safe wrapper — no-ops if the pixel is
 * blocked by an ad-blocker or hasn't finished loading (base code in index.html
 * already queues calls made before fbevents.js arrives).
 */
export function fbEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", name, params);
    }
  } catch { /* blocked — fine */ }
}
